



























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class FrameBox extends Vue {
    @Prop({ default: 'rgba(0, 0, 0, 0.49)' }) public outsideColor!: string;
    @Prop({ default: 'transparent' }) public innerColor!: string;
    @Prop({ default: '182px' }) public innerHeight!: string;
    @Prop({ default: '182px' }) public innerWidth!: string;
    @Prop({ default: '#2c89cf' }) public innerBorderColor!: string;
    @Prop({ default: '4px' }) public innerBorderSize!: string;
    @Prop({ default: '58px' }) public innerBorderHeight!: string;
    @Prop({ default: '58px' }) public innerBorderWidth!: string;
    @Prop({ default: 1 }) public topGrow!: number;
    @Prop({ default: 1 }) public bottomGrow!: number;

    public boxVariableStyle = {
        '--outside-color': this.outsideColor,
        '--top-grow': this.topGrow,
        '--bottom-grow': this.bottomGrow,
        '--inner-color': this.innerColor,
        '--inner-height': this.innerHeight,
        '--inner-width': this.innerWidth,
        '--inner-border-color': this.innerBorderColor,
        '--inner-border-size': this.innerBorderSize,
        '--inner-border-half-size': this.halfBorderSize,
        '--inner-border-height': this.innerBorderHeight,
        '--inner-border-width': this.innerBorderWidth,
    };

    get halfBorderSize(): string {
        const halfSize = parseInt(this.innerBorderSize.replace('px', ''), 10) / 2;
        return `${halfSize}px`;
    }

}
